
























































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { Reimbursement } from "@/shared/types";
import Widget from "@/shared/components/Widget.vue";
import Button from "@/shared/components/ui/Button.vue";
import ReimbursedYearlySummary from "@/employee/components/healthcareExpenseV2/ReimbursedYearlySummary.vue";
import ReimbursedRow from "@/employee/components/healthcareExpenseV2/ReimbursedRow.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useExpenseBalanceSummaryStore } from "@/employee/store/expenseBalanceSummary";
import { useExpenseReimbursedStore } from "@/employee/store/expenseReimbursed";
import { useExpenseReimbursedSummaryStore } from "@/employee/store/expenseReimbursedSummary";

@Component({
  components: {
    Widget,
    Button,
    Pagination,
    ReimbursedRow,
    ReimbursedYearlySummary,
    GenericLoadingSpinner
  }
})
export default class HealthcareExpensesReimbursed extends Vue {
  expenseReimbursedSummary = useExpenseReimbursedSummaryStore();
  expenseReimbursed = useExpenseReimbursedStore();
  expenseBalanceSummaryStore = useExpenseBalanceSummaryStore();

  mounted (): void {
    this.expenseReimbursed.load();
    this.expenseBalanceSummaryStore.loadState();
  }

  get anyPages (): boolean {
    return this.expenseReimbursed.hasPages;
  }

  get page (): number {
    return this.expenseReimbursed.currentPage;
  }

  get numberOfPages (): number {
    return this.expenseReimbursed.pageCount;
  }

  get rangeOfPages (): number[] {
    return this.expenseReimbursed.pageRange;
  }

  get isCurrentPageEntirelySelected (): boolean {
    return this.expenseReimbursed.currentPageSelected;
  }

  get numberOfReimbursements (): number {
    return this.expenseReimbursed.totalNumberOfReimbursements;
  }

  onSwitchPage (pageNumber): void {
    this.expenseReimbursed.loadPage({ page: pageNumber } as any);
  }

  getReimbursedList (): Reimbursement[] {
    return this.expenseReimbursed.getExpensesList(this.page);
  }

  collapseRow (): void {
    this.getReimbursedList().forEach((element, index) => {
      this.$refs.row[index].collapseReimbursement();
    });
  }

}
